import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgLightning = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M23.602 12.925a.875.875 0 0 0-.547-.62l-6.301-2.363 1.604-8.02a.875.875 0 0 0-1.498-.766L4.61 14.281a.875.875 0 0 0 .328 1.422l6.304 2.364-1.6 8.011a.875.875 0 0 0 1.498.766l12.25-13.125a.874.874 0 0 0 .212-.794Zm-11.64 10.481 1.146-5.729a.875.875 0 0 0-.547-.99l-5.78-2.172L16.036 4.6l-1.144 5.73a.875.875 0 0 0 .547.99l5.775 2.166-9.252 9.921Z" />
  </svg>
);
export default SvgLightning;
